export const AiTaggingTourService = Symbol('AiTaggingTourService');
